<template>
    <nav
        class="pagination is-centered is-rounded"
        role="navigation"
        aria-label="pagination"
    >
        <aside
            v-if="perPage != 5"
            class="pagination__per-page"
        >
            <p>Per page:</p>
            <select
                :value="perPage"
                :disabled="total <= 25"
                @change="changePerPage($event.target.value)"
            >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
            </select>
        </aside>

        <section class="pagination__navigation">
            <div class="pagination__page">
                <input
                    :value="currentPage"
                    type="text"
                    :disabled="lastPage === 1"
                    @change="($event) => changePage($event.target.value)"
                />

                <span class="pagination__count">of {{ lastPage }}</span>

                <p class="pagination__total">({{ total }} total {{ model }})</p>
            </div>

            <div class="pagination__buttons">
                <button
                    class="btn pagination__previous"
                    :disabled="currentPage <= 1"
                    @click.prevent="changePage(parseInt(currentPage) - 1)"
                >
                    <span class="icon-chevron-left"></span>
                </button>

                <button
                    class="btn pagination__next"
                    :disabled="currentPage >= lastPage"
                    @click.prevent="changePage(parseInt(currentPage) + 1)"
                >
                    <span class="icon-chevron-right"></span>
                </button>
            </div>
        </section>
    </nav>
</template>

<script>
export default {
    props: {
        perPage: {
            type: Number,
            required: true,
            default: () => 25,
        },
        currentPage: {
            type: Number,
            required: true,
            default: () => 1,
        },
        lastPage: {
            type: Number,
            required: true,
            default: () => 2,
        },
        total: {
            type: Number,
            required: true,
            default: () => 100,
        },
        model: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            perPageOptions: [25, 50, 100, 200],
        }
    },

    methods: {
        isCurrentPage(page) {
            return this.currentPage === page
        },

        changePage(page) {
            if (page > this.lastPageNumber) {
                page = this.lastPageNumber
            } else if (page < 1) {
                page = 1
            }

            this.$emit('paginate', {
                perPage: this.perPage,
                currentPage: page,
                lastPage: this.lastPage,
                total: this.total,
            })
        },

        changePerPage(newPerPage) {
            this.$emit('paginate', {
                perPage: newPerPage,
                currentPage: this.page,
                lastPage: this.lastPage,
                total: this.total,
            })
        },
    },
}
</script>
